import { POST } from "~/api/_common/http"

import { defineFetcher } from "../_common/defineFetcher"

type Param = {
  id: number
  category_name: "event" | "magazine" | "new_grad_job" | "short_internship" | "long_internship"
  short_internship_schedule_id?: number
  event_schedule_id?: number
}

export const fetchPostApplication = defineFetcher((param: Param): Promise<unknown> => {
  return POST("/application", param)
})
